import { render, staticRenderFns } from "./AdministerIssuerCards.vue?vue&type=template&id=9ca65a86&scoped=true"
import script from "./AdministerIssuerCards.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdministerIssuerCards.vue?vue&type=script&setup=true&lang=ts"
import style0 from "@/components/issuers/styles/issuer-components-style.css?vue&type=style&index=0&id=9ca65a86&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca65a86",
  null
  
)

/* custom blocks */
import block0 from "@/components/issuers/locales/i18n-administer-issuer-cards.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ftses-smartregion%2Fstadtkarte%2Fuis%2Fproficontrol-ui%2Fsrc%2Fcomponents%2Fissuers%2FAdministerIssuerCards.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports